import {
  CardFamilyAnswer,
  DataSourceCard,
  NoDataInfo,
  RecommendationScreen,
} from 'components'

import { Device } from 'components/Device'
import './styles.scss'
import { useFamily } from 'context/hooks/useFamily'
import { type QuestionType } from 'types/services/Family'

import {
  decideIconSrcAtNoDataInfo,
  decideTitleAtNoDataInfo,
} from 'utils/utils'

import { handleAnswer } from 'utils/familyUtils'

import useQuery from 'context/hooks/useQuery'

function Pregnancy() {
  const device = Device.useDevice()
  const { cardInfoSections, basesWithoutData, basesWithTimeout } = useFamily()

  const devicePrefix = device.prefix()

  const {
    cpf,
    nis,
    familyCode,
    fieldName: fieldNameQuery,
    basesNames,
    basesQuery,
  } = useQuery()

  const dataSourceCard = () => {
    return (
      <div
        className={`container-dataSourceCard ${devicePrefix ?? 'undefined'}`}
      >
        {cardInfoSections?.map(({ base, pregnancy, collectDate }) =>
          pregnancy !== undefined && pregnancy.cardsInfos.length > 0 ? (
            <DataSourceCard
              key={base}
              title={basesNames[base]}
              collectDate={collectDate ?? ''}
            >
              <div className="content-cardsBases">
                {pregnancy.cardsInfos.map(
                  ({
                    question,
                    answer,
                    type,
                    isAlert,
                    fieldName = '',
                  }: QuestionType) => {
                    const url = `?cpf=${cpf}&nis=${nis}&bases=${JSON.stringify(
                      basesQuery
                    )}${
                      familyCode.length > 0 ? `&familyCode=${familyCode}` : ''
                    }&fieldName=${fieldName}&currenteBase=${base}&area=Gravidez&infosRecommedation=${JSON.stringify(
                      {
                        question,
                        answer: handleAnswer(answer, type),
                        justification: 'ainda não implementado',
                        isAlert,
                      }
                    )}`

                    return (
                      <CardFamilyAnswer
                        key={question}
                        question={question}
                        answer={handleAnswer(answer, type)}
                        isAlert={isAlert}
                        url={url}
                      />
                    )
                  }
                )}
              </div>
            </DataSourceCard>
          ) : (
            <DataSourceCard
              key={base}
              title={basesNames[base]}
              collectDate={collectDate ?? ''}
            >
              <NoDataInfo
                iconSrc={decideIconSrcAtNoDataInfo(
                  basesWithoutData,
                  basesWithTimeout,
                  base
                )}
                title={decideTitleAtNoDataInfo(
                  basesWithoutData,
                  basesWithTimeout,
                  base,
                  'Gravidez'
                )}
                showIcon
              />
            </DataSourceCard>
          )
        )}
      </div>
    )
  }

  return (
    <main className={`container-pregnancy ${devicePrefix ?? 'undefined'}`}>
      <section className="container-pregnancy__cards">
        {fieldNameQuery.length === 0 ? (
          dataSourceCard()
        ) : (
          <RecommendationScreen />
        )}
      </section>
    </main>
  )
}

export default Pregnancy
